import crudHandler from "./_crud"
import {convertArrayToObject} from '../../components/TreeTable/utils';

const entity = 'reservation'

const initialState = {
	entities: {},
	is_fetching: false,
	active: undefined,
	upcomingReservations: 0,
	save: false,
 };

export default (state=initialState , action) => {
	const { type, payload, response } = action
	switch (type) {
		case `LOAD_${entity.toUpperCase()}S_AND_REMAINS`: {
			//  It first transform the array into an object.
			let items = convertArrayToObject(response);
            console.log('items: ', items)
			return {
			   ...state,
			   entities: {...state.entities, ...items},
			   is_fetching: false,
			};
		}
		case 'SET_UPCOMING_RESERVATIONS': {
			return {
				...state,
				upcomingReservations: response,
			}
		}
		case 'ADD_UPCOMING_RESERVATIONS': {
			let upcomingReservations = typeof state.upcomingReservations == 'number' ? (
				state.upcomingReservations + 1
			) : (
				1
			)

			return {
				...state,
				upcomingReservations,
			}
		}
		case `ADD_${entity.toUpperCase()}`: {
			const entity_id = response.id || response._id;

			return {
			...state,
			entities: {
				...state.entities,
				[entity_id]: {
					...state[entity_id],
					...response,
				},
			},
			};
      	}
		case `UPDATE_${entity.toUpperCase()}`: {
			const entity_id = response.id || response._id;
			let org = state.entities[entity_id];

			if(!org){
				return state
			}

			return {
				...state,
				entities: {
					...state.entities,
					[entity_id]: {
						...org,
						...response,
					},
				},
			};
      	}
		case `FETCH_${entity.toUpperCase()}S`: {
			return {
			   ...state,
			   is_fetching: true,
			};
		}
		case 'SAVE_RESERVATION': {
			return {
				...state,
				save: payload,
			}
		}
		case `UNLOAD_${entity.toUpperCase()}S`: {
			return {
				...state,
				entities: {},
				is_fetching: false,
			};
		}
		case 'LOGOUT': {
			return initialState;
		}
		default:
			// state = crudHandler(state, action, entity)
			return state
	}
}
